import React from 'react';
import MetricAndUpDown from '@/pages/dashboard/components/MetricAndUpDown';
import { MetricsTableColumn } from '@/pages/dashboard/components/PerformanceMetricsTable/config/type';
import {formatNum, formatPercentNum, getUpAndDownStatus} from '@/pages/dashboard/utils/utils';

const metrics = { Day: 'DAU', Week: 'WAU', Month: 'MAU', };
const onlyHeaders = {
  Day: [
    { key: '30d_ltv', header: 'LTV30', width: 200, format: '0.00' },
    { key: '180d_ltv', header: 'LTV180', width: 200, format: '0.00' },
  ],
  Week: [
    // { key: 'register_payer', header: 'Register Payer', width: 200, format: '0', },
  ],
  Month: [
  ]
};

/*
  宽表列名配置
  widthLarge: 指标显示最大长度10位数
  widthMid: 指标显示最大长度8位数
  表头标题最少能放下11为数超出用省略号表示，列宽取指标以及表头标题两者的最大值
  20: th & td padding 值
  const widthLarge = 220
  const widthMid = 205
*/
const widthLarge = 220 - 20;
const widthMid = 205 - 20;

function getGroupCols(selected: string[]): MetricsTableColumn<any>[] {
  const th: MetricsTableColumn<any>[] = [];

  selected.filter(ele => ele !== 'accumulated').forEach(ele => {
    th.push({
      key: ele,
      header: ele.replace(ele[0], ele[0].toLocaleUpperCase()),
      width: 200,
      align: 'center',
      render: (record) => (<span className='db-PerformanceMetricsTable__text'>{ record[`${ele}_name`]}</span>)
    });
  });

  return th;
}

function decimalPlaces(format = '') {
  return (format.split('.')[1] ?? '').length;
}

/**
 * @desc 格式化函数
 * @param val 值
 * @param format 格式： '0.0', '0.0%'
 * @param unit 单位：$
 * @returns {string}
 */
function formatVal(val: string | number = '', format: string, unit = '') {
  val = val ?? '';
  format = format?.trim() ?? '';

  if (format.includes('%')) {
    val = formatPercentNum(parseFloat(val), decimalPlaces(format.replace('%', '')));
  } else if (format[0] === '0') {
    val = formatNum(parseFloat(val), !!unit, format === '0');
  }

  return `${  val}`;
}

export function render() {
  return (
    record: any,
    rowKey: string,
    recordIndex: number,
    column: any,
    columnIndex: number
  ) => {
    const val: string = formatVal(record[column.key], column.format) || '-';
    const dod: string = record[`${column.key  }_dod`] ?? '';
    const isSummary = ['Sum', 'Average'].includes(record.date);
    const status = getUpAndDownStatus(dod, isSummary);
    const formatDod = isSummary ? '' : formatPercentNum(dod, 1, true);

    return (
      <MetricAndUpDown
        metric={val}
        updown={{ data: formatDod, status }}
        className=''
        style={{}}
        hasTooltip={false}
      />
    );
  };
}

/* */

export function getColumns(
  timeType: string,
  groups: string[] = [],
  explainInfo: any = {}
): MetricsTableColumn<any>[] {
  const dateCol: MetricsTableColumn<any> = { key: 'date', header: 'Date', width: 120, align: 'center', fixed: 'left' };
  const groupCols: MetricsTableColumn<any>[] = getGroupCols(groups);
  const metricCols: MetricsTableColumn<any>[] = [
    { key: 'total_pay_amount', header: 'Total Revenue($)', width: widthMid + 40, format: '0.00' },
    { key: 'pay_amount', header: 'Revenue($)', width: widthMid, format: '0.00' },
    { key: 'active_users', header: metrics[timeType], width: widthMid, format: '0' },
    { key: 'arppu', header: 'ARPPU($)', width: widthMid, format: '0.00' },
    { key: 'arpu', header: 'ARPU($)', width: widthMid, format: '0.00' },
    { key: 'paid_users', header: 'Payer', width: widthMid, format: '0' },
    { key: 'payer_rate', header: 'Payer%', width: widthMid, format: '0.00%' },
    { key: 'arpp', header: 'ARPP', width: widthMid, format: '0.00' },
    // { key: 'new_payer_rate', header: 'Payer%(new users)', width: widthLarge + 40, format: '0.00%' },
    { key: 'new_paid_users', header: 'New Payer', width: widthMid, format: '0' },
    { key: 'new_pay_amount', header: 'Revenue(new users)', width: widthLarge + 40, format: '0.00' },
    { key: 'new_arppu', header: 'New users ARPPU($)', width: widthLarge + 40, format: '0.00' },
    // { key: 'new_user_arpu', header: 'New users ARPU($)', width: widthMid + 50, format: '0.00' },
    { key: 'total_pay_days', header: 'Total Pay Days', width: widthMid + 10, format: '0' },
    ...onlyHeaders[timeType]
  ];

  metricCols.forEach((col: any) => {
    col.align = 'right';
    col.render = render();

    // 指标说明
    if (explainInfo?.[col.rainbowKey]) {
      col.explain = explainInfo[col.rainbowKey];
    }
  });

  return [dateCol, ...groupCols, ...metricCols];
}
